import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <ul className="breadcrumb">
      {items.map((item, index) => (
        <li key={index} className="breadcrumb-item">
          {item.path && index < items.length - 1 ? (
            <Link to={item.path}>{item.label}</Link>
          ) : (
            item.label
          )}
        </li>
      ))}
    </ul>
  );
}
